import { render } from "./FourthComponent.vue?vue&type=template&id=4fd64dc2&scoped=true"
import script from "./FourthComponent.vue?vue&type=script&lang=js"
export * from "./FourthComponent.vue?vue&type=script&lang=js"

import "./FourthComponent.vue?vue&type=style&index=0&id=4fd64dc2&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4fd64dc2"]])

export default __exports__